import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription } from "rxjs";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { ContactUsTO } from "src/app/data/schema/Subscriptions/ContactUsTO";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-contact-us",
    templateUrl: "./profile-contact-us.component.html",
    styleUrls: ["./profile-contact-us.component.scss"]
})
export class ProfileContactUsComponent implements OnInit, OnDestroy {
    public loading$: Observable<boolean>;
    public formGroup: UntypedFormGroup;
    public cardData: ContactUsTO;

    private clearFormSubscription: Subscription;

    constructor(
        private translate: TranslateService,
        private profileService: ProfileService,
        private snackBar: SnackbarService
    ) {
        this.loading$ = this.profileService.getLoadingAsync();

        this.cardData = {
            subject: "",
            message: ""
        };

        this.clearFormSubscription = this.profileService.getClearEmailFormAsync().subscribe((mustClear) => {
            if (mustClear) {
                this.cardData = {
                    subject: "",
                    message: ""
                };

                this.formGroup.patchValue({
                    subject: "",
                    message: ""
                });
            }
        });

        this.formGroup = new UntypedFormGroup({
            subject: new UntypedFormControl({ value: this.cardData.subject, disabled: false }, Validators.required),
            message: new UntypedFormControl({ value: this.cardData.message, disabled: false }, Validators.required)
        });

        this.formGroup.markAllAsTouched();
    }

    ngOnInit(): void {
        this.profileService.getLoggedUser();
    }

    ngOnDestroy(): void {
        this.clearFormSubscription.unsubscribe();
        this.profileService.clear();
    }

    public send(): void {
        this.cardData.subject = this.formGroup.value.subject;
        this.cardData.message = this.formGroup.value.message;

        if (!this.formGroup.valid) {
            this.translate.get("MESSAGES.REQUIRED").subscribe((res) => {
                this.snackBar.showMessage(res);
            });
            return;
        }

        this.profileService.sendSupportEmail(this.cardData);
    }
}
